import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"space-between"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "Video Control Panel")
], -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"display":"flex","gap":"20px","flex-wrap":"wrap"} }
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"display":"flex","flex-wrap":"wrap","gap":"10px"} }
const _hoisted_6 = { style: {"align-items":"center","gap":"10px"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Loop start point ", -1)
const _hoisted_8 = { style: {"align-items":"center","gap":"10px"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Loop end point ", -1)
const _hoisted_10 = { style: {"align-items":"center","gap":"10px"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Audio start point ", -1)
const _hoisted_12 = { style: {"display":"flex","align-items":"center","gap":"10px"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" option: ")
const _hoisted_14 = { style: {"display":"flex","gap":"10px","align-items":"center","margin-top":"20px"} }
const _hoisted_15 = { style: {"flex":"1"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_slider = _resolveComponent("a-slider")!
  const _component_PlayCircleTwoTone = _resolveComponent("PlayCircleTwoTone")!
  const _component_PauseCircleTwoTone = _resolveComponent("PauseCircleTwoTone")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"height":"100%"} }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (_ctx.videoUrl !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("video", {
                ref: "videoRef",
                src: _ctx.videoUrl,
                style: {"max-width":"500px","width":"100%","max-height":"500px"},
                onLoadedmetadata: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onReadyPlay && _ctx.onReadyPlay(...args))),
                onTimeupdate: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.timeUpdate && _ctx.timeUpdate(...args)))
              }, null, 40, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_a_input_number, {
                    value: _ctx.slider[0],
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.slider[0]) = $event)),
                    step: 0.1,
                    min: 0,
                    max: _ctx.slider[1] - 0.1
                  }, null, 8, ["value", "step", "max"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_a_input_number, {
                    value: _ctx.slider[1],
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.slider[1]) = $event)),
                    step: 0.1,
                    min: _ctx.slider[0] + 0.1,
                    max: _ctx.duration
                  }, null, 8, ["value", "step", "min", "max"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_a_input_number, {
                    value: _ctx.audioStartTime,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.audioStartTime) = $event)),
                    step: 0.1,
                    min: 0,
                    max: _ctx.duration
                  }, null, 8, ["value", "step", "max"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_a_select, {
                    value: _ctx.stopAtAudio,
                    style: {"min-width":"100px"},
                    options: _ctx.stopAtAudioList,
                    onChange: _ctx.onChangeStopAtAudio
                  }, null, 8, ["value", "options", "onChange"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_slider, {
                  value: _ctx.slider,
                  range: "",
                  min: 0,
                  max: _ctx.duration,
                  step: 0.1,
                  onChange: _ctx.onChangeSlider
                }, null, 8, ["value", "max", "step", "onChange"])
              ]),
              (!_ctx.isPlay)
                ? (_openBlock(), _createBlock(_component_PlayCircleTwoTone, {
                    key: 0,
                    style: {"font-size":"40px","cursor":"pointer"},
                    onClick: _ctx.playVideo
                  }, null, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_PauseCircleTwoTone, {
                    key: 1,
                    style: {"font-size":"40px","cursor":"pointer"},
                    onClick: _ctx.pauseVideo
                  }, null, 8, ["onClick"]))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}